import { useState, type ReactNode } from "react";
import { AutoComplete } from "@volca/ui/components/ui/autocomplete";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { PeriodOption } from "./types";

export const PeriodSelector = ({
  options,
  value,
  onValueChange,
  status,
}: {
  options: PeriodOption[];
  value?: string;
  onValueChange: (value: string) => void;
  /**
   * Rendered at the end of the label's row. Beside the selector instead, anything
   * here takes width the period needs; on the label's line it costs nothing, since
   * "Pay Period" is two words and the rest of that row was empty.
   */
  status?: ReactNode;
}) => {
  const [searchValue, setSearchValue] = useState("");

  return (
    <Stack className="w-full" align="start" gap={2}>
      <Stack
        className="w-full"
        direction="row"
        align="center"
        justify="between"
        gap={2}
      >
        <Text variant="label" tone="muted">
          Pay Period
        </Text>
        {status}
      </Stack>
      <div className="w-full min-w-0 [&_.absolute.top-0]:min-w-[260px]">
        <AutoComplete
          selectedValue={value ?? ""}
          onSelectedValueChange={onValueChange}
          searchValue={searchValue}
          onSearchValueChange={setSearchValue}
          items={options}
          placeholder="Select a pay period"
          fullWidth
        />
      </div>
    </Stack>
  );
};
